import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'offers-catalog-body.no-offers-available-title': {
    id: 'offers-catalog-body.no-offers-available-title',
    defaultMessage: 'No offers available',
    description: 'Title for "No Data View" section for offers catalog',
  },
});
